export const getNormalizedLocale = locale => {
  return locale.replace("-", "_");
};
/**
 * Tetra provides locale strings with underscore ("en_US") but React components expects hyphens ("en-US")
 * @param {String} locale
 * @returns {String}
 */
export const hyphenateLocale = locale => locale.replace("_", "-");
